import { render, staticRenderFns } from "./Scustomer.vue?vue&type=template&id=75be3f03&"
import script from "./Scustomer.vue?vue&type=script&lang=ts&"
export * from "./Scustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports